import { Navigate, Outlet, useLocation } from "react-router-dom";
import type { JSX } from "react";
import routes from "routes";
import { useAppContext } from "utils/hooks";

export const ProtectedRoute = (): JSX.Element => {
  const { authenticated } = useAppContext();
  const location = useLocation();

  if (!authenticated) {
    return <Navigate to={routes.internal.login} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
